module.exports = __webpack_public_path__ + "img/rocket.00c42920.png";